
import config from './config'

export let aws_config = {
    Auth: {
        identityPoolId: config.cognito.IdentityPoolId, //REQUIRED - Amazon Cognito Identity Pool ID
        region: config.awsRegion, // REQUIRED - Amazon Cognito Region
        userPoolId: config.cognito.UserPoolId, //OPTIONAL - Amazon Cognito User Pool ID
        userPoolWebClientId: config.cognito.ClientId, //OPTIONAL - Amazon Cognito Web Client ID

        cookieStorage: {
            domain: (window.location.hostname === 'localhost') ? "localhost" : config.cognito.cookieStorage.host,
            secure: (window.location.hostname === 'localhost') ? false : config.cognito.cookieStorage.secure,
            path: '/',
            expires: 365,
        },


    },
    Storage: {
        AWSS3: {
            bucket: config.audienceBucket, //REQUIRED -  Amazon S3 bucket
            region:  config.awsRegion,
            level: 'private',
            // set a default custom prefix as none. AWS amplify lib prepend 'private/...' etc. in the generation of 
            // download links.
            customPrefix: {
                private: '',
                public: '',
                protected: '',
            },
        }
    }
};
